import React from 'react';
import AjaxPromises from '../../../../utils/AjaxPromises';
import UserStore from '../../../../stores/UserStore';
import NotificationActions from '../../../../actions/NotificationActions';

class JoryCancel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };

        this.cancel = this.cancel.bind(this);
    }

    cancel() {
        AjaxPromises.POST('api/jory/cancel-transaction', UserStore.getApiData({
            ShipmentId: this.props.ShipmentId,
        })).then(res => {
            if (!res.Result) {
                NotificationActions.error('Transaction cancellation failed: ', res.Message);
            }
        });
    }

    render() {
        return (
            <div className='checkout-completed'>

                <div className='checkout-biotrack__title'>
                    LeafPay Debit
                </div>

                <div className='checkout-overdue__txt'>
                    Transaction processing, click below to cancel
                </div>

                <div className='row' style={{margin:0}}>
                    <div
                        className='checkout-overdue__btn checkout-overdue__no'
                        onClick={this.cancel}
                    >
                        Cancel
                    </div>
                </div>
            </div>
        );
    }
}

export default JoryCancel;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/electronic/JoryCancel.react.jsx